import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogButton from "@/shared/ui/SogButton.vue";
import apiVehicleRegistration from "@/modules/VehicleRegistration/api";
import { useSpinner } from "@/shared/composables/SogSpinner";

interface Props {
  item: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'GdvMessageIdComponent',
  props: {
    item: { default: undefined }
  },
  setup(__props: any) {

const _spinner = useSpinner();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

//"21bbfb259545435ab1b9a19efbb3750d"
async function onDownload() {
  if (!props.item) return;
  try {
    _spinner.show();
    await apiVehicleRegistration.downloadGdvMessageFile(props.item);
  } finally {
    _spinner.hide();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogButton, {
    tooltip: "Gdv-Nachricht runterladen",
    onClick: onDownload
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.item), 1)
    ]),
    _: 1
  }))
}
}

})